(function () {
  var root = document.querySelector('[data-ti-cfg]');
  if (!root) return;
  var dataEl = document.querySelector('[data-ti-cfg-data]');
  if (!dataEl) return;
  var DATA = JSON.parse(dataEl.textContent);
  DATA.variants = [];

  // ---- Quantity-band pricing (loaded from a theme asset; NEVER computed) ----
  // JSON: { classic|premium|luxury: { "SIZE|PRINT": { base, breaks:[[minQty,price],...] } } }
  var PRICING = {};
  if (DATA.pricingUrl) {
    fetch(DATA.pricingUrl)
      .then(function (r) { return r.json(); })
      .then(function (j) { PRICING = j || {}; if (typeof render === 'function') render(); })
      .catch(function () {});
  }
  // ---- Variant-ID map (from a theme asset) — the storefront /products/<h>.js caps at 250 variants,
  // so we load the full color|size|print -> variant_id table here. Fixes add-to-cart for colors past 250.
  var VARMAP = {};
  if (DATA.variantsUrl) {
    fetch(DATA.variantsUrl)
      .then(function (r) { return r.json(); })
      .then(function (j) { VARMAP = j || {}; })
      .catch(function () {});
  }
  // ---- #5/#6 Design preview: print-location coordinate map (config); which side (front/back) per location ----
  var LOCMAP = {};
  if (DATA.locationsUrl) {
    fetch(DATA.locationsUrl)
      .then(function (r) { return r.json(); })
      .then(function (j) { LOCMAP = j || {}; if (typeof render === 'function' && state.step === 4) render(); })
      .catch(function () {});
  }
  // Per-colour garment photos: { "<colour name>": { front: url, back: url } }. Generated + hosted on Shopify Files.
  var MOCKUPS = {};
  if (DATA.mockupsUrl) {
    fetch(DATA.mockupsUrl)
      .then(function (r) { return r.json(); })
      .then(function (j) { MOCKUPS = j || {}; if (typeof render === 'function' && state.step === 4) render(); })
      .catch(function () {});
  }
  // Which tier is this product? Match the title against the pricing keys.
  function tierKey() {
    var t = (DATA.productTitle || '').toLowerCase();
    if (t.indexOf('classic') !== -1) return 'classic';
    if (t.indexOf('premium') !== -1) return 'premium';
    if (t.indexOf('luxury') !== -1) return 'luxury';
    return null;
  }
  var TIER = tierKey();
  // base price + breaks for the current print, at a given size, from the band table.
  function bandEntry(size) {
    if (!TIER || !state.print) return null;
    var table = PRICING[TIER]; if (!table) return null;
    return table[size + '|' + state.print] || null;
  }
  // unit price (in dollars) for a size at a given TOTAL quantity — picks the right break.
  function bandUnitDollars(size, totalQ) {
    var e = bandEntry(size); if (!e) return null;
    var price = e.base;
    (e.breaks || []).forEach(function (b) { if (totalQ >= b[0]) price = b[1]; });
    return price;
  }
  function hasBandPricing() { return !!(TIER && PRICING[TIER]); }

  // color name -> hex, driven by the section setting (admin-editable), with fallbacks
  var HEX = {};
  (DATA.colorHex || '').split('\n').forEach(function (line) {
    var m = line.split('=');
    if (m.length >= 2) {
      var name = m[0].trim().toLowerCase();
      var hex = m.slice(1).join('=').trim();
      if (name && hex) HEX[name] = hex;
    }
  });
  // basic word fallbacks so an unlisted color still renders something sensible
  var WORD = {
    'yellow':'#f2c200','white':'#ffffff','navy':'#1f2d4a','beige':'#d8c3a5','black':'#111111',
    'blue':'#2f5fc4','bronze':'#a97142','brown':'#5a3b28','gold':'#c9a227','gray':'#8a8f96',
    'grey':'#8a8f96','green':'#2e8b45','orange':'#e8792b','pink':'#e58fb0','purple':'#7d4a9e',
    'red':'#c0392b','silver':'#c9ccd1','aqua':'#3fb6c6','teal':'#2b8a8f','maroon':'#7a2233',
    'charcoal':'#2f3438','mint':'#9fe0c0','peach':'#f6c6a3','berry':'#8e2b4b','cream':'#f4efe2',
    'royal':'#2f5fc4','forest':'#1f4d38','tan':'#d2b48c','olive':'#6b8e23'
  };
  function hexFor(name) {
    var n = (name || '').toLowerCase().trim();
    if (HEX[n]) return HEX[n];                 // exact from admin map
    for (var k in HEX) { if (n.indexOf(k) === 0) return HEX[k]; } // prefix from admin map
    var words = n.split(/[^a-z]+/);
    for (var i = 0; i < words.length; i++) { if (WORD[words[i]]) return WORD[words[i]]; }
    return '#c9ccd1';                          // last-resort neutral
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  // step 0 Ordering · 1 Color · 2 Print · 3 Sizes · 4 Artwork · 5 Review
  var LOCATIONS = [
    'Left chest front', 'Right chest front',
    'Full front', 'Full back',
    'Upper back', 'Middle back'
  ];
  var LAST_STEP = 5;
  var furthest = 0;       // #2 furthest step reached — completed steps stay clickable
  var state = {
    step: 0,
    path: null,              // 'standard' | 'quote'
    color: null,
    print: null,
    qty: {},
    locations: [],           // selected print locations
    artworkByLoc: {},        // location -> file name
    artworkFileByLoc: {},    // location -> File
    designHelp: false,       // #15 "I need help creating my design" → routes to quote
    notes: ''
  };

  // Sizes in canonical order for the Review breakdown (#7). Unknown sizes fall to the end.
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL'];
  function orderedSizes() {
    return (DATA.sizes || []).slice().sort(function (a, b) {
      var ia = SIZE_ORDER.indexOf(a), ib = SIZE_ORDER.indexOf(b);
      if (ia === -1) ia = 99; if (ib === -1) ib = 99;
      return ia - ib;
    });
  }
  // "S x 5, M x 10, L x 3" — only sizes with qty > 0, in size order.
  function sizeBreakdownText() {
    return orderedSizes().filter(function (s) { return state.qty[s] > 0; })
      .map(function (s) { return s + ' × ' + state.qty[s]; }).join(', ');
  }
  var body = root.querySelector('[data-ti-body]');
  var stepsEl = root.querySelector('[data-ti-steps]');
  var backBtn = root.querySelector('[data-ti-back]');
  var nextBtn = root.querySelector('[data-ti-next]');
  var preview = root.querySelector('[data-ti-preview]');

  // Unit price (cents) for a size. Uses the quantity-band table (priced on the TOTAL
  // qty across all sizes, per spec #4) when available; falls back to the variant base price.
  // Multi-location jobs need an individually prepared quote.
  function isMultiLocation() { return state.locations.length > 1; }

  function unitPriceFor(size) {
    if (isMultiLocation()) return null;
    if (!state.color || !state.print) return null;
    if (hasBandPricing()) {
      var d = bandUnitDollars(size, totalQty());
      if (d != null) return Math.round(d * 100);
    }
    var match = DATA.variants.find(function (v) {
      return v.options.indexOf(state.color) !== -1 &&
             v.options.indexOf(size) !== -1 &&
             v.options.indexOf(state.print) !== -1;
    });
    return match ? match.price : null;
  }
  // Resolve the real variant id for color|size|print. Prefer the full VARMAP (all variants);
  // fall back to the 250-capped /products.js list only if the map hasn't loaded.
  function variantIdFor(size) {
    if (state.color && state.color !== '__custom__' && state.print && TIER && VARMAP[TIER]) {
      var id = VARMAP[TIER][state.color + '|' + size + '|' + state.print];
      if (id) return id;
    }
    var v = DATA.variants.find(function (x) {
      return x.options.indexOf(state.color) !== -1 &&
             x.options.indexOf(size) !== -1 &&
             x.options.indexOf(state.print) !== -1;
    });
    return v ? v.id : null;
  }
  function variantFor(size) {
    var id = variantIdFor(size);
    return id ? { id: id } : null;
  }
  function totalQty() { var t = 0; for (var s in state.qty) t += (state.qty[s] || 0); return t; }
  function orderTotalCents() {
    var t = 0;
    for (var s in state.qty) {
      var n = state.qty[s] || 0; if (!n) continue;
      var p = unitPriceFor(s); if (p == null) continue;
      t += p * n;
    }
    return t;
  }
  function isExtended(size) { return /^(2xl|3xl|4xl|5xl)$/i.test((size || '').trim()); }

  // #1 Apparel quantity limits on the TOTAL across sizes (freely mixable). Screen print (1-4 Color) = 10–250;
  // DTF / full colour = 5–75. Determined by the selected print method.
  function isDTF() { return /full colour|full color|dtf|dtg/i.test(state.print || ''); }
  function qtyBounds() {
    // MOQ is 10 total pieces across all sizes (freely mixable), max 250. DTF (full colour) min 5.
    return isDTF() ? { min: 5, max: 75, dtf: true } : { min: 10, max: 250, dtf: false };
  }
  // At-min / at-max message for the sizes step (spec #1). Returns HTML or ''.
  function qtyMessageHTML() {
    var b = qtyBounds(), q = totalQty();
    if (q === 0) return '';
    if (q > b.max) {
      var url = quotePrefillUrl();
      return 'Ordering ' + b.max + ' or more? Let’s talk. Large runs are priced individually so you get the best rate. <a href="' + url + '">Request a quote</a> or email <a href="mailto:order@thingsinked.com">order@thingsinked.com</a>';
    }
    if (q < b.min) {
      return 'Our minimum is ' + b.min + (b.dtf ? ' (full colour)' : '') + '. Add a few more, or email us at <a href="mailto:order@thingsinked.com">order@thingsinked.com</a>.';
    }
    return '';
  }
  function quotePrefillUrl() {
    var q = { product: DATA.productTitle || '', type: 'Custom apparel', color: (typeof colorLabel === 'function' ? colorLabel() : state.color) || '',
      print: state.print || '', qty: totalQty() ? totalQty() + ' pcs' : '',
      sizes: (typeof sizeBreakdownText === 'function' ? sizeBreakdownText() : '') };
    var params = Object.keys(q).filter(function (k) { return q[k] !== '' && q[k] != null; })
      .map(function (k) { return k + '=' + encodeURIComponent(q[k]); }).join('&');
    return '/pages/quote-upload?' + params;
  }
  // Live "Total: N pcs" pill + at-min/at-max message under the size grid.
  function updateQtyTotal() {
    var pill = root.querySelector('[data-ti-qtytotal]');
    if (pill) { var t = totalQty(); pill.textContent = t ? 'Total: ' + t + ' pcs' : ''; }
    var note = root.querySelector('[data-ti-qty-note]');
    if (note) { var m = qtyMessageHTML(); if (m) { note.innerHTML = m; note.hidden = false; } else { note.hidden = true; } }
  }
  // #7 itemised breakdown: group selected sizes by unit price, standard vs extended separated.
  // Returns [{label, qty, unitCents, lineCents, extended}] in size order.
  function priceLines() {
    var out = [];
    orderedSizes().forEach(function (s) {
      var n = state.qty[s] || 0; if (!n) return;
      var p = unitPriceFor(s);
      out.push({ size: s, qty: n, unitCents: p, lineCents: p == null ? null : p * n, extended: isExtended(s) });
    });
    return out;
  }

  function render() {
    if (state.step > furthest) furthest = state.step;
    // #2 Clickable step bar: steps up to the furthest reached (except current) are buttons.
    Array.prototype.forEach.call(stepsEl.children, function (el, i) {
      var done = i < state.step, current = i === state.step, reachable = i <= furthest && !current;
      el.className = 'ti-cfg__step' + (current ? ' is-active' : '') + (done ? ' is-done' : '') + (reachable ? ' is-clickable' : '');
      if (current) { el.setAttribute('aria-current', 'step'); } else { el.removeAttribute('aria-current'); }
      el.setAttribute('aria-disabled', reachable ? 'false' : 'true');
      el.style.cursor = reachable ? 'pointer' : 'default';
    });
    var s = state.step, html = '';
    if (s === 0) {
      html = '<h2 class="ti-cfg__h">How would you like to order?</h2><p class="ti-cfg__hint">Most orders are self-service. Bigger or mixed jobs? A real person can help.</p>' +
        '<div class="ti-cfg__cards">' +
          '<div class="ti-cfg__card' + (state.path === 'standard' ? ' is-sel' : '') + '" data-path="standard">' +
            '<span class="ti-cfg__card-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
            '<span class="ti-cfg__card-badge">Fastest</span>' +
            '<p class="ti-cfg__card-t">Standard order</p>' +
            '<p class="ti-cfg__card-d">Configure it yourself and check out online. We send a free digital proof after payment — nothing prints until you approve.</p>' +
          '</div>' +
          '<div class="ti-cfg__card' + (state.path === 'quote' ? ' is-sel' : '') + '" data-path="quote">' +
            '<span class="ti-cfg__card-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></span>' +
            '<p class="ti-cfg__card-t">Complex order? Request a Quote</p>' +
            '<p class="ti-cfg__card-d">Tournaments, corporate packages, mixed sizes or colors — talk to a real person who\'ll build the order with you.</p>' +
          '</div>' +
        '</div>';
    } else if (s === 1) {
      var customSelected = state.color === '__custom__';
      html = '<h2 class="ti-cfg__h">Choose a color</h2><p class="ti-cfg__hint">Pick a stock color, or request a custom color.</p><div class="ti-cfg__swatches">' +
        DATA.colors.map(function (c) {
          return '<span class="ti-cfg__sw' + (state.color === c ? ' is-sel' : '') + '" data-color="' + c.replace(/"/g,'') + '" title="' + c.replace(/"/g,'') + '" style="background:' + hexFor(c) + '"></span>';
        }).join('') +
        '<span class="ti-cfg__sw ti-cfg__sw--custom' + (customSelected ? ' is-sel' : '') + '" data-color-custom title="Custom color"' +
          (state.customHex ? ' style="background:' + state.customHex + '"' : '') + '>' +
          (state.customHex ? '' : '<svg viewBox="0 0 24 24" fill="none" stroke="#5b6472" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>') +
        '</span></div>' +
        '<div class="ti-cfg__custom" data-ti-custom' + (customSelected ? '' : ' hidden') + '>' +
          '<p class="ti-cfg__hint" style="margin:1rem 0 0.5rem">Custom color — pick or paste a hex code. Our team will match it.</p>' +
          '<div class="ti-cfg__custom-row">' +
            '<input type="color" data-ti-colorpick value="' + (state.customHex || '#165900') + '">' +
            '<input type="text" data-ti-hex placeholder="#165900" value="' + (state.customHex || '') + '" maxlength="7">' +
          '</div>' +
        '</div>';
    } else if (s === 2) {
      html = '<h2 class="ti-cfg__h">Print method</h2><p class="ti-cfg__hint">How should we print your design?</p><div class="ti-cfg__opts">' +
        DATA.prints.map(function (p) {
          return '<div class="ti-cfg__opt' + (state.print === p ? ' is-sel' : '') + '" data-print="' + p.replace(/"/g,'&quot;') + '"><span class="ti-cfg__opt-name">' + p + '</span></div>';
        }).join('') + '</div>';
    } else if (s === 3) {
      var b3 = qtyBounds();
      html = '<h2 class="ti-cfg__h">Sizes & quantities</h2><p class="ti-cfg__hint">Mix sizes freely — enter how many of each. Minimum ' + b3.min + ', maximum ' + b3.max + (b3.dtf ? ' for full colour.' : '.') + '</p><div class="ti-cfg__sizes">' +
        orderedSizes().map(function (sz) {   // #1 canonical XS→3XL order (Luxury option order is reversed)
          var up = unitPriceFor(sz);
          return '<div class="ti-cfg__sizerow"><label>' + sz + '</label>' +
            '<input type="number" min="0" value="' + (state.qty[sz] || '') + '" data-size="' + sz + '" placeholder="0">' +
            '<small style="color:#8a93a0">' + (up != null ? money(up) : '') + '</small></div>';
        }).join('') + '</div>' +
        '<div class="ti-cfg__totalpill" data-ti-qtytotal></div>' +
        '<div class="ti-cfg__note" data-ti-qty-note hidden></div>';
    } else if (s === 4) {
      html = '<h2 class="ti-cfg__h">Your artwork</h2><p class="ti-cfg__hint">Tell us where your design prints and share your files. We review every file and send a proof before printing.</p>' +
        '<div class="ti-cfg__checks" style="margin-bottom:1rem">' +
          '<label class="ti-cfg__check' + (!state.designHelp ? ' is-sel' : '') + '"><input type="radio" name="ti-artmode" data-ti-artmode="have"' + (!state.designHelp ? ' checked' : '') + '><span class="ti-cfg__check-name">I have print-ready artwork</span></label>' +
          '<label class="ti-cfg__check' + (state.designHelp ? ' is-sel' : '') + '"><input type="radio" name="ti-artmode" data-ti-artmode="help"' + (state.designHelp ? ' checked' : '') + '><span class="ti-cfg__check-name">I need help creating my design</span></label>' +
        '</div>';
      if (state.designHelp) {
        html += '<div class="ti-cfg__note">No problem — tell us what you need and we’ll design it for you. We’ll send you a price before anything is printed.</div>' +
          '<div class="ti-cfg__field"><label>Tell us about your design</label><textarea data-ti-notes rows="4" placeholder="Colours, logo, text, references…">' + (state.notes || '') + '</textarea></div>';
      } else {
        html += '<div class="ti-cfg__field"><label>Print location(s) — pick one or more</label><div class="ti-cfg__loc-opts">' +
          LOCATIONS.map(function (o) {
            return '<button type="button" class="ti-cfg__chip' + (state.locations.indexOf(o) !== -1 ? ' is-sel' : '') + '" data-ti-locchip="' + o + '">' + o + '</button>';
          }).join('') + '</div></div>' +
          // #5/#6 live placement preview + per-location upload, combined in one compact card each
          (state.locations.length
            ? '<p class="ti-cfg__mock-note">This shows placement only — we’ll send you a real proof of your artwork before anything prints.</p>' + mockupsUploadHTML()
            : '<p class="ti-cfg__hint" style="margin-top:1rem">Select at least one location above to add artwork.</p>') +
          '<div class="ti-cfg__field"><label>Production notes (optional)</label><textarea data-ti-notes rows="3" placeholder="Anything we should know?">' + (state.notes || '') + '</textarea></div>';
      }
    } else if (s === 5) {
      var q = totalQty();
      var locLine = state.locations.length ? state.locations.join(', ') : '—';
      var artLines = state.locations.map(function (o) {
        return '<div class="ti-cfg__review-row"><span>Artwork · ' + o + '</span><b>' + (state.artworkByLoc[o] || 'send later') + '</b></div>';
      }).join('');
      // #7 itemised price: group by unit price so extended sizes show on their own line.
      // #4 If the customer chose Quote (or design-help) at step 1, show no prices here — the
      // order panel reads "Quote", and Review must never disagree with it.
      var pl = priceLines();
      var priceRows = '';
      if (!isMultiLocation() && !state.designHelp && state.path !== 'quote' && pl.length && pl.every(function (r) { return r.unitCents != null; })) {
        // merge consecutive lines that share the same unit price into one row
        var groups = {};
        pl.forEach(function (r) {
          var key = r.unitCents + '|' + (r.extended ? 'ext' : 'std');
          if (!groups[key]) groups[key] = { qty: 0, unitCents: r.unitCents, extended: r.extended };
          groups[key].qty += r.qty;
        });
        priceRows = Object.keys(groups).map(function (k) {
          var g = groups[k];
          return '<div class="ti-cfg__review-row"><span>' + g.qty + ' × ' + (g.extended ? 'extended (2XL/3XL)' : 'standard') +
            ' @ ' + money(g.unitCents) + '</span><b>' + money(g.unitCents * g.qty) + '</b></div>';
        }).join('');
      }
      html = '<h2 class="ti-cfg__h">Review your order</h2>' +
        '<div class="ti-cfg__review-row"><span>Color</span><b>' + (colorLabel() || '-') + '</b></div>' +
        '<div class="ti-cfg__review-row"><span>Print</span><b>' + (state.print || '-') + '</b></div>' +
        '<div class="ti-cfg__review-row"><span>Sizes</span><b>' + (sizeBreakdownText() || '—') + '</b></div>' +
        '<div class="ti-cfg__review-row"><span>Total qty</span><b>' + q + ' pcs</b></div>' +
        '<div class="ti-cfg__review-row"><span>Print location(s)</span><b>' + locLine + '</b></div>' +
        artLines +
        priceRows +
        (priceRows ? '<div class="ti-cfg__review-row is-total"><span>Total</span><span>' + money(orderTotalCents()) + '</span></div>' : '');
      // #5 design placement preview
      if (state.locations.length) {
        html += '<h3 class="ti-cfg__mock-title">Where your design will print</h3>' +
          '<p class="ti-cfg__mock-note">This shows placement only — we’ll send you a real proof of your artwork before anything prints.</p>' +
          mockupsHTML();
      } else {
        html += '<p class="ti-cfg__mock-note">No print location selected yet. <a href="#" data-ti-back-to-art>Choose one</a>.</p>';
      }
      // #4 No "how would you like to finish?" here — chosen at step 1; order panel carries the action.
    }
    if (s === LAST_STEP && isMultiLocation()) {
      html = '<h2 class="ti-cfg__h">Contact us for a custom quote</h2>' +
        '<p class="ti-cfg__hint">For printing in multiple locations, please contact us for a custom quote.</p>' +
        '<div class="ti-cfg__note">Your selected print locations: ' + state.locations.join(', ') + '</div>' +
        '<p class="ti-cfg__hint">Click Contact us to open our quote form, or go back to change your print locations.</p>' +
        '<p class="ti-cfg__hint">If you selected artwork files here, please attach them again on the quote form.</p>';
    }
    body.innerHTML = html;
    bind();
    updateSummary();
    if (s === 3) updateQtyTotal();   // #1 total pill + min/max message on arrival
    backBtn.style.visibility = s === 0 ? 'hidden' : 'visible';
    if (s === LAST_STEP) nextBtn.textContent = isMultiLocation() ? 'Contact us →' : (state.path === 'quote' || state.designHelp) ? 'Request a Quote →' : 'Add to Cart →';
    else nextBtn.textContent = 'Continue →';
    nextBtn.disabled = !canContinue();
  }

  function bind() {
    // ordering-process cards
    root.querySelectorAll('[data-path]').forEach(function (el) {
      el.addEventListener('click', function () {
        var p = el.getAttribute('data-path');
        state.path = p;
        if (p === 'quote') { window.location.href = '/pages/quote-upload'; return; }
        render();
      });
    });

    root.querySelectorAll('[data-color]').forEach(function (el) {
      el.addEventListener('click', function () { state.color = el.getAttribute('data-color'); updatePreview(); render(); });
    });
    // custom color swatch
    var customSw = root.querySelector('[data-color-custom]');
    if (customSw) customSw.addEventListener('click', function () { state.color = '__custom__'; updatePreview(); render(); });
    var colorpick = root.querySelector('[data-ti-colorpick]');
    if (colorpick) colorpick.addEventListener('input', function () {
      state.customHex = colorpick.value; updatePreview(); var hx = root.querySelector('[data-ti-hex]'); if (hx) hx.value = colorpick.value;
      updateSummary();
    });
    var hexInput = root.querySelector('[data-ti-hex]');
    if (hexInput) hexInput.addEventListener('input', function () {
      var val = hexInput.value.trim(); if (val && val[0] !== '#') val = '#' + val;
      if (/^#[0-9a-fA-F]{6}$/.test(val)) { state.customHex = val; updatePreview(); if (colorpick) colorpick.value = val; }
      updateSummary();
    });

    root.querySelectorAll('[data-print]').forEach(function (el) {
      el.addEventListener('click', function () { state.print = el.getAttribute('data-print'); render(); });
    });
    root.querySelectorAll('input[data-size]').forEach(function (el) {
      el.addEventListener('input', function () {
        state.qty[el.getAttribute('data-size')] = parseInt(el.value) || 0;
        updateSummary(); nextBtn.disabled = !canContinue(); updateQtyTotal();
      });
    });
    // print-location chips (multi-select) — adding/removing shows one upload field per location
    root.querySelectorAll('[data-ti-locchip]').forEach(function (el) {
      el.addEventListener('click', function () {
        var o = el.getAttribute('data-ti-locchip');
        var i = state.locations.indexOf(o);
        if (i === -1) { state.locations.push(o); }
        else {
          state.locations.splice(i, 1);
          // keep the file in session in case they re-add, but drop the visible name
          delete state.artworkByLoc[o];
          delete state.artworkFileByLoc[o];
        }
        render();
      });
    });
    // Upload button → open its hidden file input programmatically (works in every browser).
    root.querySelectorAll('[data-ti-uploadbtn]').forEach(function (btn) {
      var input = document.getElementById(btn.getAttribute('data-ti-uploadbtn'));
      if (!input) return;
      btn.addEventListener('click', function () { input.click(); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); input.click(); }
      });
    });
    // one file input per selected location
    root.querySelectorAll('[data-ti-file]').forEach(function (fileInput) {
      fileInput.addEventListener('change', function () {
        var o = fileInput.getAttribute('data-ti-file');
        var f = fileInput.files && fileInput.files[0];
        if (f) { state.artworkByLoc[o] = f.name; state.artworkFileByLoc[o] = f; render(); }
      });
    });
    // #15 design-help toggle
    root.querySelectorAll('[data-ti-artmode]').forEach(function (el) {
      el.addEventListener('change', function () { state.designHelp = el.getAttribute('data-ti-artmode') === 'help'; render(); });
    });
    var notes = root.querySelector('[data-ti-notes]');
    if (notes) notes.addEventListener('input', function () { state.notes = notes.value; });

    // review-step order path radios
    // #5 "Choose one" on Review with no location → back to the Artwork step.
    var backToArt = root.querySelector('[data-ti-back-to-art]');
    if (backToArt) backToArt.addEventListener('click', function (e) {
      e.preventDefault(); state.step = 4; render();
      body.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function slug(s) { return (s || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  // #5/#6 The garment photo for the chosen colour, per view ('front' | 'back' | 'leftArm' | 'rightArm').
  // Prefer the MOCKUPS map (real Monday Merch photos per colour+view); fall back to front, then variant/media/preview.
  function garmentImage(view) {
    if (!state.color || state.color === '__custom__') return preview ? preview.getAttribute('src') : '';
    var mk = MOCKUPS[state.color];
    if (mk) {
      if (view && mk[view]) return mk[view];   // exact view (back / leftArm / rightArm)
      if (mk.front) return mk.front;           // default to front
      // last resort: any available view
      var anyKey = Object.keys(mk)[0];
      if (anyKey) return mk[anyKey];
    }
    var v = DATA.variants.find(function (x) { return x.options.indexOf(state.color) !== -1 && x.image; });
    if (v && v.image) return v.image;
    var cslug = slug(state.color);
    var m = (DATA.media || []).find(function (u) {
      var fn = (u || '').split('/files/').pop().split('?')[0].toLowerCase();
      return fn.indexOf('tshirt-' + cslug) === 0;
    });
    return m || (preview ? preview.getAttribute('src') : '');
  }
  // One location card: the FIXED placement diagram for that location (same image regardless of colour/variant).
  function mockupCardHTML(loc) {
    var cfg = LOCMAP[loc] || {};
    var img = cfg.diagram || garmentImage(cfg.view);
    return '<figure class="ti-mock">' +
        '<div class="ti-mock__img">' + (img ? '<img src="' + img + '" alt="' + loc + '">' : '') + '</div>' +
        '<figcaption class="ti-mock__cap">' + loc + '</figcaption>' +
      '</figure>';
  }
  // All chosen locations, side by side (spec #5). Empty string if none. (Review step — no upload.)
  function mockupsHTML() {
    if (!state.locations.length) return '';
    return '<div class="ti-mock__row">' + state.locations.map(mockupCardHTML).join('') + '</div>';
  }
  // Compact combined card: FIXED placement diagram + location label + that location's own upload area (Artwork step).
  function mockupUploadCardHTML(loc, i) {
    var cfg = LOCMAP[loc] || {};
    var img = cfg.diagram || garmentImage(cfg.view);
    var fn = state.artworkByLoc[loc];
    var id = 'ti-artwork-' + i;
    return '<figure class="ti-mock ti-mock--up">' +
        '<div class="ti-mock__img">' + (img ? '<img src="' + img + '" alt="' + loc + '">' : '') + '</div>' +
        '<figcaption class="ti-mock__cap">' + loc + '</figcaption>' +
        '<div class="ti-cfg__upload ti-mock__up' + (fn ? ' is-filled' : '') + '" role="button" tabindex="0" data-ti-uploadbtn="' + id + '">' +
          (fn ? '✓ ' + fn : '📎 Upload artwork') +
          '<input type="file" id="' + id + '" data-ti-file="' + loc + '" accept=".png,.jpg,.jpeg,.avif,.heic,image/png,image/jpeg,image/avif,image/heic" hidden>' +
        '</div>' +
      '</figure>';
  }
  function mockupsUploadHTML() {
    if (!state.locations.length) return '';
    return '<div class="ti-mock__row">' + state.locations.map(mockupUploadCardHTML).join('') + '</div>';
  }
  // Use a neutral garment layer and independent print artwork for clean color previews.
  function setupMockupColorPreview(preview, kind) {
    var outlines = {"classic":"M 0.40191 0.05662 L 0.41308 0.05662 L 0.42823 0.06459 L 0.45215 0.07177 L 0.48565 0.07656 L 0.53509 0.07416 L 0.55981 0.06778 L 0.58134 0.05742 L 0.59091 0.05742 L 0.60367 0.06459 L 0.61882 0.06778 L 0.62440 0.07177 L 0.68421 0.09250 L 0.76156 0.12520 L 0.78309 0.13716 L 0.80702 0.16029 L 0.96491 0.32935 L 0.96491 0.33812 L 0.83493 0.47289 L 0.82616 0.47289 L 0.79426 0.45375 L 0.78868 0.45455 L 0.79825 0.61324 L 0.80702 0.94099 L 0.45455 0.94258 L 0.18820 0.93939 L 0.20096 0.59250 L 0.20893 0.45534 L 0.20415 0.45455 L 0.17464 0.47209 L 0.16427 0.47209 L 0.03509 0.34450 L 0.03509 0.33493 L 0.21372 0.13955 L 0.23684 0.12600 L 0.28150 0.10526 L 0.35726 0.07576 L 0.37560 0.06619 L 0.39633 0.06061 Z","premium":"M 0.40670 0.05662 L 0.41707 0.05662 L 0.43062 0.06380 L 0.45136 0.07018 L 0.48325 0.07496 L 0.53429 0.07257 L 0.56061 0.06539 L 0.57735 0.05662 L 0.58692 0.05662 L 0.60128 0.06380 L 0.61802 0.06778 L 0.62281 0.07177 L 0.69617 0.09729 L 0.77193 0.12998 L 0.78230 0.13557 L 0.81659 0.16986 L 0.96730 0.32855 L 0.96730 0.33812 L 0.83732 0.47528 L 0.82695 0.47528 L 0.80223 0.46093 L 0.78868 0.45694 L 0.79665 0.58214 L 0.81021 0.93461 L 0.80861 0.94498 L 0.43461 0.94737 L 0.18979 0.94338 L 0.20096 0.65311 L 0.21132 0.45774 L 0.20654 0.45774 L 0.17544 0.47528 L 0.16667 0.47528 L 0.03589 0.34769 L 0.03589 0.33812 L 0.21611 0.14035 L 0.23445 0.12919 L 0.28549 0.10526 Z","luxury":"M 0.40191 0.05502 L 0.41228 0.05502 L 0.42743 0.06380 L 0.44976 0.07097 L 0.48086 0.07576 L 0.52791 0.07416 L 0.55263 0.06778 L 0.57576 0.05502 L 0.58692 0.05502 L 0.75279 0.11882 L 0.78309 0.13397 L 0.96571 0.32855 L 0.96571 0.33812 L 0.90909 0.39633 L 0.83812 0.47687 L 0.82935 0.47687 L 0.79027 0.45455 L 0.78549 0.45534 L 0.79904 0.65789 L 0.80702 0.86443 L 0.80781 0.94577 L 0.42982 0.94896 L 0.18820 0.94418 L 0.19777 0.68660 L 0.21132 0.45614 L 0.20415 0.45694 L 0.17464 0.47608 L 0.16427 0.47608 L 0.14035 0.44976 L 0.03429 0.34609 L 0.03429 0.33732 L 0.12919 0.23365 L 0.21372 0.13636 L 0.26077 0.11244 L 0.35726 0.07416 L 0.37560 0.06380 L 0.38198 0.06380 Z"};
    var images = {"classic":"https://cdn.shopify.com/s/files/1/0598/3361/4418/files/ti-classic-clean-shirt-v1.png?v=1792613456","premium":"https://cdn.shopify.com/s/files/1/0598/3361/4418/files/ti-premium-clean-shirt-v1.png?v=1792613456","luxury":"https://cdn.shopify.com/s/files/1/0598/3361/4418/files/ti-luxury-clean-shirt-v1.png?v=1792613456"};
    var ns = 'http://www.w3.org/2000/svg';
    var id = 'ti-clean-shirt-' + Math.random().toString(36).slice(2,9);
    var defsSvg = document.createElementNS(ns,'svg');
    defsSvg.setAttribute('width','0'); defsSvg.setAttribute('height','0');
    defsSvg.setAttribute('aria-hidden','true');
    defsSvg.style.cssText = 'position:absolute;pointer-events:none;overflow:hidden';
    defsSvg.innerHTML = '<defs><clipPath id="'+id+'-edge" clipPathUnits="objectBoundingBox"><path d="'+outlines[kind]+'"/></clipPath><filter id="'+id+'-color" x="0" y="0" width="100%" height="100%" color-interpolation-filters="sRGB"><feColorMatrix in="SourceGraphic" type="matrix" result="cloth"/><feTurbulence type="fractalNoise" baseFrequency="0.009" numOctaves="2" seed="8" result="noise"/><feColorMatrix in="noise" type="matrix" values="3.2 0 0 0 -0.9 0 3.2 0 0 -0.9 0 0 3.2 0 -0.9 0 0 0 0 1" result="dye"/><feBlend in="cloth" in2="dye" mode="multiply" result="dyedCloth"/><feComposite data-ti-cloth-output in="cloth" in2="SourceAlpha" operator="in"/></filter></defs>';
    document.body.appendChild(defsSvg);
    var matrix = defsSvg.querySelector('feColorMatrix');
    var overlay = document.createElementNS(ns,'svg');
    overlay.setAttribute('viewBox','0 0 800 800');
    overlay.setAttribute('aria-hidden','true');
    overlay.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;pointer-events:none;display:none';
    overlay.innerHTML = '<rect x="294" y="235" width="212" height="238" fill="none" stroke="currentColor" stroke-width="2"/><text x="400" y="320" fill="currentColor" text-anchor="middle" font-family="Arial, sans-serif" font-size="28" font-weight="600" letter-spacing="5"><tspan x="402">YOUR</tspan><tspan x="402" dy="39">DESIGN</tspan><tspan x="402" dy="39">HERE</tspan></text>';
    var parent = preview.parentElement;
    var latest = null;
    var loaded = false;
    var activated = false;
    var image = new Image();
    function paint() {
      if (!loaded || !latest) return;
      var hex = latest.hex;
      var rgb = [1,3,5].map(function(i){return parseInt(hex.slice(i,i+2),16)/255;});
      var tieDye = /tie[\s-]*dye/i.test(latest.name || '');
      var channels = (tieDye ? [1,1,1] : rgb).map(function(c){return Math.max(0.10,c);});
      matrix.setAttribute('values',channels.map(function(c){return [0.2126*c,0.7152*c,0.0722*c,0,0].join(' ');}).join(' ')+' 0 0 0 1 0');
      defsSvg.querySelector('[data-ti-cloth-output]').setAttribute('in',tieDye ? 'dyedCloth' : 'cloth');
      var brightness = rgb[0]*0.2126+rgb[1]*0.7152+rgb[2]*0.0722;
      overlay.style.color = brightness > 0.48 ? '#51483f' : '#f2e8d9';
      if (!activated) {
        activated = true;
        if (window.getComputedStyle(parent).position === 'static') parent.style.position = 'relative';
        parent.style.background = 'radial-gradient(ellipse at 48% 40%,#eadac7,#ddc7b0)';
        preview.removeAttribute('srcset');
        preview.removeAttribute('sizes');
        preview.src = images[kind];
        preview.style.cssText += ';filter:url(#'+id+'-color);clip-path:url(#'+id+'-edge);object-fit:contain;transform:none;transition:none';
        parent.appendChild(overlay);
        overlay.style.display = 'block';
      }
    }
    image.onload = function(){
      var ready = image.decode ? image.decode() : Promise.resolve();
      ready.then(function(){loaded=true;paint();},function(){loaded=true;paint();});
    };
    image.src = images[kind];
    return function(hex,name){latest={hex:hex,name:name};paint();};
  }
  
  var previewKind = /luxury/i.test(DATA.handle || '') ? 'luxury' : /premium/i.test(DATA.handle || '') ? 'premium' : 'classic';
  var colorizeMockup = preview ? setupMockupColorPreview(preview, previewKind) : null;
  function updatePreview() {
    if (!preview || !state.color) return;
    var hex = state.color === '__custom__' ? (state.customHex || '#165900') : hexFor(state.color);
    if (!/^#[0-9a-f]{6}$/i.test(hex)) return;
    if (!colorizeMockup) {
      var kind = /luxury/i.test(DATA.handle || '') ? 'luxury' : /premium/i.test(DATA.handle || '') ? 'premium' : 'classic';
      colorizeMockup = setupMockupColorPreview(preview, kind);
    }
    preview.style.transition = 'none';
    preview.style.transform = '';
    colorizeMockup(hex, state.color);
    preview.alt = (DATA.productTitle || 'T-shirt') + ' — ' + colorLabel() + ' mockup';
  }

  function colorLabel() {
    if (state.color === '__custom__') return 'Custom ' + (state.customHex || '');
    return state.color;
  }
  function isCustomColor() { return state.color === '__custom__'; }

  function updateSummary() {
    var lines = [];
    if (state.color) lines.push(['Color', colorLabel()]);
    if (state.print) lines.push(['Print', state.print.split(' ').slice(0, 2).join(' ')]);
    var bd = sizeBreakdownText(); if (bd) lines.push(['Sizes', bd]);   // #7 size breakdown in summary
    var q = totalQty(); if (q) lines.push(['Quantity', q + ' pcs']);
    if (state.locations.length) lines.push(['Locations', state.locations.length + ' spot' + (state.locations.length > 1 ? 's' : '')]);
    root.querySelector('[data-ti-sumlines]').innerHTML = lines.map(function (l) {
      return '<div class="ti-cfg__sumline"><span class="k">' + l[0] + '</span><span class="v">' + l[1] + '</span></div>';
    }).join('') || '<div class="ti-cfg__est">Start selecting options…</div>';
    // Design-help / quote path shows "Quote" instead of a $ total.
    var totalEl = root.querySelector('[data-ti-total]');
    // Preserve the label so normal single-location orders can show it again.
    if (!totalEl._tiTotalLabels && totalEl.parentElement) {
      totalEl._tiTotalLabels = [];
      var walker = document.createTreeWalker(totalEl.parentElement, 4);
      var labelNode;
      while ((labelNode = walker.nextNode())) {
        if (!totalEl.contains(labelNode) && /^\s*Total\s*:?\s*$/i.test(labelNode.nodeValue)) {
          totalEl._tiTotalLabels.push({ node: labelNode, text: labelNode.nodeValue });
        }
      }
    }
    (totalEl._tiTotalLabels || []).forEach(function (label) {
      label.node.nodeValue = isMultiLocation() ? '' : label.text;
    });
    totalEl.textContent = isMultiLocation() ? 'Custom quote required' : (state.designHelp || state.path === 'quote') ? 'Quote' : money(orderTotalCents());
    var mapEl = root.querySelector('[data-ti-map]');
    if (state.color && state.print) {
      // #3: include the size(s) in the mapping. Grid = one variant per size.
      var szs = orderedSizes().filter(function (s) { return state.qty[s] > 0; });
      var szPart = szs.length ? szs.join('/') : '—';
      mapEl.innerHTML = 'Maps to variant: <code>' + state.color + ' / ' + szPart + ' / ' + state.print.split(' ').slice(0,2).join(' ') + '</code>';
    } else { mapEl.innerHTML = ''; }
    // #8: prices are exact catalog values when band pricing is loaded — drop the "estimated" note.
    var estEl = root.querySelector('[data-ti-est]');
    if (estEl) estEl.hidden = isMultiLocation() || hasBandPricing();
  }

  function canContinue() {
    var s = state.step;
    if (s === 0) return state.path === 'standard';
    if (s === 1) return !!state.color && (!isCustomColor() || /^#[0-9a-fA-F]{6}$/.test(state.customHex || ''));
    if (s === 2) return !!state.print;
    // #1 Sizes: total must reach the minimum. (Over max still continues → routed to quote.)
    if (s === 3) { var b = qtyBounds(); return totalQty() >= b.min; }
    // Artwork: design-help path needs nothing; otherwise ≥1 location. Uploads optional (send later).
    if (s === 4) return state.designHelp ? true : state.locations.length > 0;
    return true;
  }

  // Upload one file to Cloudinary (unsigned) and return its secure CDN URL. No backend needed.
  function uploadToCloudinary(file) {
    var cloud = DATA.cloudinaryCloud, preset = DATA.cloudinaryPreset;
    if (!cloud || !preset || !file) {
      console.warn('[TI] Cloudinary skip — cloud/preset/file missing', { cloud: cloud, preset: preset, hasFile: !!file });
      return Promise.resolve(null);
    }
    var fd = new FormData();
    fd.append('file', file);
    fd.append('upload_preset', preset);
    return fetch('https://api.cloudinary.com/v1_1/' + cloud + '/auto/upload', { method: 'POST', body: fd })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.secure_url) return d.secure_url;
        console.warn('[TI] Cloudinary upload failed', d && d.error ? d.error : d);
        return null;
      })
      .catch(function (e) { console.warn('[TI] Cloudinary fetch error', e); return null; });
  }

  // Upload every selected location's artwork, return { location: url }.
  function uploadAllArtwork() {
    var jobs = state.locations.map(function (o) {
      var f = state.artworkFileByLoc[o];
      if (!f) return Promise.resolve([o, null]);
      return uploadToCloudinary(f).then(function (url) { return [o, url]; });
    });
    return Promise.all(jobs).then(function (pairs) {
      var map = {};
      pairs.forEach(function (p) { map[p[0]] = p[1]; });
      return map;
    });
  }

  function addToCart() {
    if (isMultiLocation()) { state.step = LAST_STEP; render(); return; }
    nextBtn.disabled = true; nextBtn.textContent = 'Uploading artwork…';
    uploadAllArtwork().then(function (urlByLoc) {
      var items = [];
      for (var sz in state.qty) {
        var n = state.qty[sz]; if (!n) continue;
        var v = variantFor(sz);
        if (!v) continue;
        // Every selection recorded so the merchant sees exactly what was ordered.
        var props = {
          'Color': colorLabel() || '',
          'Print method': state.print || '',
          'Print locations': state.locations.join(', ') || '—',
          'Notes': state.notes || ''
        };
        state.locations.forEach(function (o) {
          var url = urlByLoc[o];
          var name = state.artworkByLoc[o];
          // Prefix "_" hides the raw url line from the storefront cart but keeps it on the order for the merchant.
          if (url) {
            props['Artwork · ' + o] = name || 'uploaded';
            props['_Artwork file · ' + o] = url;
          } else {
            props['Artwork · ' + o] = name ? name + ' (send by email)' : 'send later';
          }
        });
        if (isCustomColor()) props['Custom color'] = state.customHex || '';
        items.push({ id: v.id, quantity: n, properties: props });
      }
      if (!items.length) { nextBtn.disabled = false; nextBtn.textContent = 'Add to Cart →'; return; }
      nextBtn.textContent = 'Adding…';
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.json(); }).then(function () {
        window.location.href = '/cart';
      });
    }).catch(function () {
      nextBtn.disabled = false; nextBtn.textContent = 'Add to Cart →';
      alert('Could not add to cart. Please try again.');
    });
  }

  nextBtn.addEventListener('click', function () {
    if (!canContinue()) return;
    if (state.step < LAST_STEP) { state.step++; render(); return; }
    if (isMultiLocation() || state.path === 'quote' || state.designHelp) { goToQuote(); return; }
    addToCart();
  });

  function goToQuote() {
    var artwork = state.designHelp ? 'Design help requested'
      : state.locations.map(function (o) {
          return state.artworkByLoc[o] ? o + ': ' + state.artworkByLoc[o] : o + ': send later';
        }).join(' · ');
    var q = {
      product: DATA.productTitle || '',
      type: 'Custom apparel',
      color: colorLabel() || '',
      print: state.print || '',
      qty: totalQty() ? totalQty() + ' pcs' : '',
      sizes: sizeBreakdownText(),
      locations: state.designHelp ? '' : state.locations.join(', '),
      artwork: artwork,
      reason: isMultiLocation() ? 'Multiple print locations - custom quote required' : state.designHelp ? 'Needs design help' : '',
      notes: state.notes || ''
    };
    var params = Object.keys(q).filter(function (k) { return q[k] !== '' && q[k] != null; })
      .map(function (k) { return k + '=' + encodeURIComponent(q[k]); }).join('&');
    window.location.href = '/pages/quote-upload?' + params;
  }
  backBtn.addEventListener('click', function () { if (state.step > 0) { state.step--; render(); } });

  // #2 Clickable step bar — jump to any reached step; keyboard-activatable.
  function stepJump(el) {
    var i = parseInt(el.getAttribute('data-step'));
    if (isNaN(i) || i > furthest || i === state.step) return;
    state.step = i; render();
    body.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  Array.prototype.forEach.call(stepsEl.children, function (el) {
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
    el.addEventListener('click', function () { stepJump(el); });
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); stepJump(el); }
    });
  });

  // Load ALL variants (Liquid product.variants caps at 250) via the product JSON endpoint.
  fetch('/products/' + DATA.handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) {
      DATA.variants = (p.variants || []).map(function (v) {
        return {
          id: v.id,
          price: v.price,
          available: v.available,
          options: v.options,
          image: v.featured_image ? v.featured_image.src : null
        };
      });
      // all product media URLs, for color-name fallback matching
      DATA.media = (p.media || []).map(function (m) { return m.src || m.preview_image && m.preview_image.src; }).filter(Boolean);
      if (!DATA.media.length && p.images) DATA.media = p.images.slice();
      render();
    })
    .catch(function () { render(); });
})();
